import { LinkButton, Paragraph, Subtitle } from '@joor/design-system'
import styled from 'styled-components'

import { DefaultLayoutProps } from '../../types'

export const DefaultLayout = ({
  title,
  text,
  linkUrl,
  linkLabel,
}: DefaultLayoutProps) => {
  return (
    <StyledContainer>
      <StyledTextColumn>
        <Subtitle>{title}</Subtitle>
        {Boolean(text) && <Paragraph>{text}</Paragraph>}
      </StyledTextColumn>
      <LinkButton href={linkUrl} target="_blank" rel="noreferrer">
        {linkLabel}
      </LinkButton>
    </StyledContainer>
  )
}

const StyledContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 20px 16px;

  a {
    margin-left: 12px;
  }
`

const StyledTextColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  justify-content: flex-start;
`
